import { Component, OnInit, ViewChild,ChangeDetectorRef} from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';
import { DomSanitizer } from '@angular/platform-browser';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-writers-statistics',
  templateUrl: './writers-statistics.component.html',
  styleUrls: ['./writers-statistics.component.css']
})
export class WritersStatisticsComponent implements OnInit {

    public activeUser         : any;
    public despositionArray   : any = AppSettings.disposition;
    public documentTypeArray  : any = AppSettings.documentType;
    public orderStatus        : any = AppSettings.orderStatus;

    public writersCategories  : any = [];

    public loading            : any = false;
    public leadIndex          : any = null;
    public warningAction      : any = null;
    public paginatePage       : any;
    public leads              : any = [];
    public comments           : any = [];
    public agentComments      : any = [];
    public qaComments         : any = [];
    public browserSub         : any;
    public agentsSub          : any;
    public agents             : any;
    public qa                 : any;
    public loader             : any;
    public writers            : any;
    public counterVal         : any = 0;
    public downloadingFile    : any = false;
    public fileUrl            : any = false;

    @ViewChild(DataTableDirective)
    public dtElement    : DataTableDirective;
    public dtOptions    : DataTables.Settings = {};
    public dtTrigger    : any = new Subject();

    public searchParams  : any = { writer_id: null, region: null, date_from: '', date_to: '' };
    public fullRangeDate : any;
    public selectedDesposition     : any;
    public base64Pipe              : any = new Base64Pipe;
    public WriterDetailFlag        : any = false;
    public csv_Loader              : any = false;
    public csv_Downloaded          : any;



    constructor(
      private authenticationService : AuthenticationService,
      private helperService         : HelperService,
      private http                  : HttpClient,
      private agentsService         : Agents,
      private cdr                   : ChangeDetectorRef,
      private sanitizer: DomSanitizer

    ) {
        this.browserSub = this.authenticationService.isBrowser.subscribe(isBrowser => {
          if (isBrowser) {
            // Get Active User
            this.activeUser = this.authenticationService.get_currentUserValue();

            // Set Defualt date range
            this.setDefualtDateRange();

            // Set Writers Categories
            if(this.activeUser.is_admin) {
                this.writersCategories = [
                                            { name: 'NFW',                value: 'NFW' },
                                            { name: 'Local Writer',       value: 'Local' },
                                            { name: 'Foreign Writer',     value: 'Foreigner' },
                                            { name: 'Inhouse Writer',     value: 'inhouse' },
                                            { name: 'Admin',              value: 'admin' },
                                            { name: 'Support',            value: 'agent' },
                                            { name: 'Sales Agent',        value: 'sales' },
                                            { name: 'Writer Manager',     value: 'writer-manager' }
                                          ];
            } else {
                this.writersCategories = [
                                            { name: 'Inhouse Writer',     value: 'inhouse' },
                                            { name: 'Local Writer',       value: 'Local' },
                                            { name: 'NFW',                value: 'NFW' },
                                            { name: 'Foreign Writer',     value: 'Foreigner' }
                                          ];
            }

            // Set Defualt Region
            this.searchParams.region = this.writersCategories[0].value;

            // Get Agents
            this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
              if (agents) {
                this.agents   = agents.agents;
                this.qa       = agents.qa;
                this.writers  = agents.writers;
              }
            });


            this.dtOptions = {
              paging: true,
              info: true,
              // ordering: false,
              pagingType: 'full_numbers',
              pageLength: 25,
              serverSide: true,
              processing: true,
              searching: false,
              'language': AppSettings.dataTableLang,
              "columnDefs": [
                { "orderable": false,                           "targets": 0 },
                { "orderable": false,                           "targets": 1 },
                { "orderable": false,                           "targets": 2 },
                { "orderable": false,                           "targets": 3 },
                { "orderable": false,                           "targets": 4 },
                { "orderable": false,                           "targets": 5 },
                { "orderable": false,                           "targets": 6 },
                { "orderable": false,                           "targets": 7 },
                { "orderable": false,                           "targets": 8 },
                { "orderable": false,                           "targets": 9 },
                { "orderable": false,                           "targets": 10 },
                { "orderable": false,                           "targets": 11 },
                { "orderable": false,                           "targets": 12 },
                { "orderable": false,                           "targets": 13 },
                { "orderable": false,                           "targets": 14 },
              ],
              "order": [[ 0, "desc" ]],
              ajax: (dataTablesParameters: any, callback) => {
                // Show Loader
                this.loading = true;
                // console.log("dataTablesParameters", dataTablesParameters);

                let url  = AppSettings.API_ENDPOINT + 'writers/get-writers-statistics';
                let dtParams = {
                                writer_id         : this.searchParams.writer_id,
                                region            : this.searchParams.region,
                                date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                                date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                                start             : dataTablesParameters.start,
                                length            : dataTablesParameters.length,
                                order             : dataTablesParameters.order,
                                columns           : dataTablesParameters.columns
                              };

                // For Record Serial Numbers
                this.paginatePage = dataTablesParameters.start;
                this.leads.data = [];
                this.helperService.httpPostRequestsDecryp(url, dtParams)
                  .then( resp => {
                      this.leads        = JSON.parse(resp);

                      // console.log("this.leads", this.leads);

                      // Set Default page len
                      this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                      // Hide Loader
                      this.loading = false;

                      callback({
                        recordsTotal: this.leads.total,
                        recordsFiltered: this.leads.total,
                        // recordsFiltered: resp['recordsFiltered'],
                        // recordsFiltered: 1000,
                        data: []
                      });

                      this.cdr.detectChanges();
                      // this.downloadCsv();

                      // // $(".paginate_button .current").css("color", "white");
                      // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                      $('div.dataTables_length select').addClass('dt-form-control');
                      $('div.dataTables_filter input').addClass('dt-form-control');
                  })
                  .catch(error => {
                      // Set loader false
                      this.loading = false;

                      // // Rerender DT in case of failure
                      // this.rerender();

                      console.log("error: ",error);
                  });
              },
              columns: [
                // { data: 'multiDelete' },
                { data: 'id' },
                { data: 'name' },
                { data: 'timestamp' },
                { data: 'client_info' },
                { data: 'price_noOfPages' },
                { data: 'due_date' },
                { data: 'academic_level' },
                { data: 'assignedTo' },
                { data: 'writerDD' },
                { data: 'orderStatus' },
                { data: 'action' },
                { data: 'action' },
                { data: 'action' },
                { data: 'action' },
                { data: 'action' },
              ],
              // Use this attribute to enable the responsive extension
              responsive: false
            }
          }
        });
    }

    ngOnInit() {

    }

    ngAfterViewInit(){
      this.dtTrigger.next();
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();
      if (typeof this.agentsSub != 'undefined') {
        //prevent memory leak when component destroyed
        this.browserSub.unsubscribe();
        this.agentsSub.unsubscribe();
      }
    }

    rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

        // Destroy the table first
        dtInstance.destroy();

        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    }

    splitFromTo(){
      if(this.fullRangeDate) {
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }

      this.rerender();
    }

    closeWarningModal() {
      this.cdr.detectChanges();

      console.log("$('#warning_modal' + this.leadIndex): ", $('#warning_modal' + this.leadIndex));

      // Hide Modal
      ($('#warning_modal' + this.leadIndex) as any).modal('hide');

    }

    openWarningModal(index, type) {
      if(type == 'Decrease' && this.leads.data[index].warnings == 0)
        return;

      this.leadIndex     = index;
      this.warningAction = { type: type, writerName: this.leads.data[index].name };

      // Detect changes
      this.cdr.detectChanges();

      // Open Modal
      ($("#warning_modal" + index) as any).modal('show');
      $(".modal-backdrop").click(function(){

          $("#warning_modal" + index).modal("hide");
      });
    }

    giveWarning() {
      // Hide Modal
      ($('#warning_modal' + this.leadIndex) as any).modal('hide');

      // Show Status Loader
      this.leads.data[this.leadIndex].settingWarning = true;

      let url = AppSettings.API_ENDPOINT + "writers/give-warning-to-writers";
      let data = { id: this.leads.data[this.leadIndex].id, type: this.warningAction.type };

      this.helperService.httpPostRequests(url, data).then(resp => {
          if(typeof resp != "undefined" && resp.status == "OK") {
            // Remove the Agent
            Swal.fire('', resp.message, 'success');

            if(this.warningAction.type == 'Add')
              this.leads.data[this.leadIndex].warnings++;
            else if(this.warningAction.type == 'Decrease' && this.leads.data[this.leadIndex].warnings != 0)
              this.leads.data[this.leadIndex].warnings--;
          }
          if(typeof resp != "undefined" && resp.status == "ERROR") {
            Swal.fire('', resp.message, 'error');
          }

          // Hide Status Loader
          this.leads.data[this.leadIndex].settingWarning = false;
      }).catch(errr => {
          // Hide Status Loader
          this.leads.data[this.leadIndex].settingWarning = true;
      });
    }

    setDeadlineTimer(time){
      if(typeof $ != "undefined"){
        // Set the date we're counting down to
        var countDownDate = new Date(time).getTime();

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if(days > 0){
          return days + 'd : ' + hours + 'hr : ' +  + minutes + 'Min' ;
        }
        else if(days == 0){
          return hours + 'hr : ' +  + minutes + 'Min' ;
        }
        else{
          return "-";
        }
      }
    }

    setDefualtDateRange() {
      let startDate = new Date();
          startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);

      this.fullRangeDate = [startDate, new Date()];

      if(this.fullRangeDate) {
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }
    }

    writerDetail(i){
        if(typeof $ != "undefined") {
          this.WriterDetailFlag = true;

          // Detect changes
          this.cdr.detectChanges();

          $('#writerDetail'+ i).modal('show');

          $(".modal-backdrop").click(function(){
              $("#writerDetail"+i).modal("hide");
          });
        }
    }

    downloadCsv() {
      // Show Loader
      this.downloadingFile = true;

      let url = AppSettings.API_ENDPOINT + "writers/download-csv-ws";
      let data = {
        user              : this.activeUser.user,
        writer_id         : this.searchParams.writer_id,
        region            : this.searchParams.region,
        date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
        date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
      };

      this.http.post(url, data, { responseType: 'text' })
       .subscribe((resp: any) => {
          var saveData = (function () {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              return function (data, fileName) {
                  var blob = new Blob([data], { type: 'application/octet-stream' });
                      url = window.URL.createObjectURL(blob);
                  a.href = url;
                  a.download = fileName;
                  a.click();
                  window.URL.revokeObjectURL(url);
              };
          }());

          saveData(resp, 'writers-statistics.csv');

          // Hide Loader
          this.downloadingFile = false;
       });
    }

    clearFilters(){
      this.fullRangeDate = '';
      this.searchParams  = { writer_id: null, region: this.writersCategories[0].value, date_from: '', date_to: '' };

      // Set Defualt date range
      this.setDefualtDateRange();

      this.rerender();
    }

    agentSearch(id, agentArr) {
      for (var i = 0; i < agentArr.length; i++) {
        if (agentArr[i].id === id) {
          return agentArr[i].name;
        }
      }
    }

    showOrderStatus(id, statusArr) {
      for (var i = 0; i < statusArr.length; i++) {
        if (statusArr[i].value === id) {
          return statusArr[i].name;
        }
      }
    }

    showStatusColor(id, statusArr) {
      for (var i = 0; i < statusArr.length; i++) {
        if (statusArr[i].value === id) {
          return statusArr[i].color;
        }
      }
    }
}
